var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"center-wrapper nav"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticStyle:{"height":"60px","width":"auto"},attrs:{"src":require("../assets/img/logo.png"),"alt":"甄宝阁"}})]),_c('img',{attrs:{"src":require("../assets/img/zbrx.png"),"alt":"甄宝阁"}})])])
}]

export { render, staticRenderFns }